<template>
  <main id="model-tiny-mce">
    <p class="model-tiny-mce__label">{{ label }}</p>
    <div
      class="model-tiny-mce__editor"
      :class="{ 'model-tiny-mce__editor--error': error }"
      ref="root"
    >
      <Editor
        api-key="no-api-key"
        :tinymce-script-src="tinymceScriptSrc"
        v-model="dataValue"
        :init="{
          toolbar_mode: 'sliding',
          plugins: plugins,
          language: 'ru',
          toolbar: 'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table mergetags | addcomment showcomments | spellcheckdialog a11ycheck typography | align lineheight | checklist numlist bullist indent outdent | emoticons charmap | removeformat',
          tinycomments_mode: 'embedded',
          tinycomments_author: 'Author name',
          images_upload_handler: fileUpload,
          mergetags_list: [
            { value: 'First.Name', title: 'First Name' },
            { value: 'Email', title: 'Email' },
          ],
        }"
        initial-value=""
      />
    </div>
    <div v-if="error" class="model-tiny-mce__error">
      {{ errorMessage }}
    </div>
  </main>
</template>

<script>
import Editor from '@tinymce/tinymce-vue';
import { upload } from "@/tools/http";

const UPLOAD_PATHS = {
  profile: "file/upload",
  cms: "upload",
  progress: "upload",
  clubs: "upload",
  projects2: "api/v1/upload/description/document",
};

export default {
    name: 'ModelTinyMce',
    components: {
      Editor,
    },
    props: {
        label: {
          type: String,
          default: '',
        },
        value: {
            type: String,
            default: '',
        },
        fileUploadDestination: {
            type: String,
            default: 'cms',
        },
        fileUploadDestinationField: {
            type: String,
            default: 'file',
        },
        error: {
          type: Boolean,
          default: false,
        },
        errorMessage: {
          type: String,
          default: '',
        },
    },
    data() {
        return {
          dataValue: this.value,
          tinymceScriptSrc: '/plugins/tinymce/tinymce.min.js',
          plugins: [
            "paste",
            "accordion",
            "advlist",
            "anchor",
            "autolink",
            "autoresize",
            "charmap",
            "code",
            "codesample",
            "directionality",
            "emoticons",
            "fullscreen",
            "help",
            "image",
            "importcss",
            "insertdatetime",
            "link",
            "lists",
            "media",
            "nonbreaking",
            "pagebreak",
            "preview",
            "quickbars",
            "save",
            "searchreplace",
            "table",
            "visualblocks",
            "visualchars",
            "wordcount",
          ],
        };
    },
    model: {
        prop: 'value',
        event: 'change',
    },
    watch: {
        dataValue(str) {
            this.$emit('change', str);
        },
    },
    methods: {
      async fileUpload(blobInfo) {
        const destination = this.fileUploadDestination;
        const fieldName = this.fileUploadDestinationField;

        const rs = await upload(
          destination,
          UPLOAD_PATHS[destination],
          fieldName,
          blobInfo.blob(),
          {},
          destination === "projects2" ? { full: true } : {}
        );

        if (destination === "cms" || destination === "clubs") {
          return rs.fileName;
        }

        if (destination === "projects2") {
          return rs;
        }

        if (rs.file) {
          return rs.file.url;
        }

        return rs.url;
      },
    },
};
</script>

<style scoped lang="scss">
@import "~@/styles/rem";
@import "~@/styles/variables";
  .model-tiny-mce {
    display: flex;
    flex-direction: column;
    place-items: center;

    &__label {
      @include set-font-size(14, 600, 20);
      margin-bottom: urem(22);
        @include on-desktop {
            @include set-font-size(16, 600, 22);
        }
    }
    &__editor {
      border-radius: urem(10);
      :deep(.tox-tinymce) {
        border-radius: urem(10);

        .tox-statusbar__branding {
          display: none;
        }
      }

      &--error {
        border: 1px solid red;
        :deep(.tox-tinymce) {
          border: none;
        }
      }
    }
    &__error {
      color: red;
      min-height: urem(20);
      padding: urem(8) 0;
      margin-top: urem(12);
      @include set-font-size(14, 400);
        word-wrap: break-word;
    }
  }
</style>
